import BellIcon from '@heroicons/react/outline/BellIcon';
import HomeIcon from '@heroicons/react/outline/HomeIcon';
import LoginIcon from '@heroicons/react/outline/LoginIcon';
import SearchIcon from '@heroicons/react/outline/SearchIcon';
import UserCircleIcon from '@heroicons/react/outline/UserCircleIcon';
import UserGroupIcon from '@heroicons/react/outline/UserGroupIcon';
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon';
import { SystemSpaceSlug } from '@tribeplatform/react-sdk/hooks';
export const SystemSpacesIcons = {
    [SystemSpaceSlug.HOME]: HomeIcon,
    [SystemSpaceSlug.SEARCH]: SearchIcon,
    [SystemSpaceSlug.NOTIFICATIONS]: BellIcon,
    [SystemSpaceSlug.PROFILE_SETTINGS]: UserCircleIcon,
    [SystemSpaceSlug.SIGNUP]: LoginIcon,
    [SystemSpaceSlug.LOGIN]: LoginIcon,
    [SystemSpaceSlug.ACCEPT_INVITATION]: LoginIcon,
    [SystemSpaceSlug.DIRECT_LOGIN]: LoginIcon,
    [SystemSpaceSlug.FORGOT_PASSWORD]: LoginIcon,
    [SystemSpaceSlug.JOIN_BY_INVITATION]: LoginIcon,
    [SystemSpaceSlug.RESET_PASSWORD]: LoginIcon,
    [SystemSpaceSlug.VERIFY_EMAIL]: LoginIcon,
    'default::members': UserGroupIcon,
    'default::spaces': ViewGridIcon,
};
//# sourceMappingURL=icons.js.map